import { Box, Button, IconButton, Typography } from "@mui/material"
import { useStyles } from "./styles"
import { useTranslation } from "react-i18next"
import { icons } from "../../../../../../utils/icons"
import { FiltersDrawer } from "../../../../../../components/filtersDrawer"
import { DinamicForm } from "../../../../../../components/dinamicForm"
import { CustomTable } from "../../../../../../components"
import { RefObject } from "react"
import { RefTable } from "../../../../../../components/table/types"
import { ColumnItem, ObjectGeneric, onChangeEvent } from "../../../../../../utils/types/generals"
import { useContextState } from "../../../../../../hooks/theme"
import { InputModel } from "../../../../../../utils/types"



const HeaderTable = ({ onClickBack, refTable, isLoading, counter, column, row, onClickTable, inputFilter, handleFilter, handleCheanFilter, filterData, titleTable, defraultChecks }:{ defraultChecks: (string | number)[]; titleTable:string; filterData: ObjectGeneric | undefined; handleCheanFilter: () => void;  handleFilter: (data?: { e?: onChangeEvent; payload?: { clean: boolean; }; }) => unknown[];  inputFilter: Record<string, InputModel>; onClickTable: ((e: any, index?: number | string | null) => void) | undefined; row: any[]; column: ColumnItem[]; onClickBack:()=>void; refTable: RefObject<RefTable>; isLoading:boolean; counter:number; }) => {

    const styles = useStyles()
    const { t } = useTranslation()
    const { colors } = useContextState()

    return (<>
        <Box sx={styles.hg100}>
            <Box sx={styles.hg90}>
                <Box sx={styles.headerLeft}>
                    <IconButton onClick={onClickBack}>{icons('arrow-left-fill')}</IconButton>
                    <Typography>{t('schedule.assigned.backToEdit')}</Typography>
                </Box>
                <Box sx={styles.headerTitle}>
                    <Typography>{titleTable}</Typography>

                    <Box sx={styles.containerFilter}>
                        <IconButton
                            sx={(styles.clean, (counter || 0) > 0 ? null : styles.hide)}
                            onClick={() => {
                                handleCheanFilter()
                            }}
                        >
                            {icons('clean')}
                        </IconButton>

                        <Box sx={styles.drawerfilter}>
                            <FiltersDrawer
                                cleanFilter={handleCheanFilter}
                                count={counter}
                            /* right={0}
                            top={50} */
                            >
                                <Box sx={styles.section}>
                                    <DinamicForm
                                        input={Object.values(inputFilter)}
                                        values={filterData ?? {}}
                                        onChange={(e) => {
                                            handleFilter({ e })
                                        }}
                                        filter={true}
                                    />
                                </Box>
                            </FiltersDrawer>
                        </Box>
                    </Box>
                </Box>
                <CustomTable
                    ref={refTable}
                    loader={isLoading}
                    dontRefresh
                    tableRadio
                    tableChecks
                    onClick={onClickTable}
                    column={column}
                    row={row}
                    color={colors}
                    selected={-1}
                    defaultChecks={defraultChecks}
                />
            </Box>
            <Box sx={styles.buttonsContainer}>
                <Button onClick={onClickBack}>{t('general.cancel')}</Button>
                <Button className="next" variant="contained" onClick={onClickBack}>
                    {t('general.continue')}
                </Button>
            </Box>
        </Box>
    </>)
}

export { HeaderTable }
